var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import WalletService from '../../api/WalletService';
import ServiceService from '../../api/ServiceService';
import GlobalVue from '../../globalVue';
import { Loading } from 'element-ui';
import PayRecord from './PayRecord.vue';
var MyWallet = (function (_super) {
    __extends(MyWallet, _super);
    function MyWallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.walletData = {};
        _this.payStatus = '-1';
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 420;
        _this.payVisible = false;
        _this.rechargePositions = [];
        _this.payMoney = '';
        _this.rechargeData = {};
        _this.payType = 12;
        _this.isQrShow = false;
        _this.qrcode_path = '';
        _this.isPayOrder = false;
        _this.isPaid = false;
        _this.timer = null;
        _this.payModalShow = false;
        return _this;
    }
    MyWallet.prototype.watchPayStatus = function (newValue, oldValue) {
        this.getList();
    };
    MyWallet.prototype.created = function () {
        this.service = WalletService.getInstance();
        this.serviceService = ServiceService.getInstance();
        this.getWallet();
        this.getList();
    };
    MyWallet.prototype.mounted = function () {
        if (this.payModalShow) {
            this.showPayModal();
        }
    };
    MyWallet.prototype.searchPayResult = function (order_id) {
        var _this = this;
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(function () {
            _this.getPayFlag(order_id);
        }, 3000);
    };
    MyWallet.prototype.getPayFlag = function (order_id) {
        var _this = this;
        var params = { order_id: order_id };
        this.serviceService
            .getPayFlag(params)
            .then(function (res) {
            if (res.data.data.is_pay == 1) {
                _this.$message.success('支付成功！');
                _this.isQrShow = false;
                _this.isPaid = true;
                clearInterval(_this.timer);
            }
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    MyWallet.prototype.recharge = function (params, loadingInstance) {
        var _this = this;
        this.service
            .getRecharge(params)
            .then(function (res) {
            loadingInstance.close();
            _this.qrcode_path = res.data.data.qrcode_path;
            _this.isQrShow = true;
            _this.searchPayResult(res.data.data.order_id);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    MyWallet.prototype.getActivity = function (recharge_money, activity_id) {
        var _this = this;
        this.payMoney = recharge_money;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getRechargeActivity({
            recharge_money: recharge_money,
            activity_id: activity_id,
        })
            .then(function (res) {
            _this.rechargeData = res.data.data;
            var params = {
                recharge_money: recharge_money,
                activity_id: activity_id,
                payment_type: 12,
                terminal_type: 1,
            };
            _this.recharge(params, loadingInstance);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    MyWallet.prototype.hidePayModal = function () {
        this.payVisible = false;
        this.payMoney = '';
        this.rechargeData = {};
        this.isQrShow = false;
        this.qrcode_path = '';
        this.isPayOrder = false;
        this.isPaid = false;
        if (this.timer)
            clearInterval(this.timer);
        this.getWallet();
        this.getList();
    };
    MyWallet.prototype.showPayModal = function () {
        var _this = this;
        if (this.rechargePositions.length || this.isPayOrder)
            return (this.payVisible = true);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getRechargePosition()
            .then(function (res) {
            loadingInstance.close();
            _this.rechargePositions = res.data.data;
            _this.payVisible = true;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    MyWallet.prototype.toPay = function (order_id) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .payBillOrder({ order_id: order_id, terminal_type: 1 })
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code === 2000) {
                _this.$confirm('订单为非待支付状态，不可支付；是否重新进行充值？', '', {
                    customClass: 'confirm',
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    center: true,
                })
                    .then(function () {
                    _this.showPayModal();
                })
                    .catch(function () {
                    _this.getList();
                });
            }
            else {
                _this.isPayOrder = true;
                _this.rechargeData = res.data.data;
                _this.qrcode_path = res.data.data.qrcode_path;
                _this.isQrShow = true;
                _this.showPayModal();
                _this.searchPayResult(order_id);
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    MyWallet.prototype.toRecharge = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .rechargeCheck()
            .then(function (res) {
            loadingInstance.close();
            var total = res.data.total;
            if (total) {
                _this.$confirm(res.data.msg, '', {
                    customClass: 'confirm',
                    confirmButtonText: total === 1 ? '去支付' : '去查看',
                    cancelButtonText: '取消',
                    center: true,
                })
                    .then(function () {
                    if (total === 1) {
                        _this.toPay(res.data.data.order_id);
                    }
                    else {
                        _this.payStatus = '0';
                    }
                })
                    .catch(function (err) {
                    _this.showPayModal();
                });
            }
            else {
                _this.showPayModal();
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    MyWallet.prototype.toPayRecord = function () {
        GlobalVue.$emit('addTab', {
            component: PayRecord,
            title: '交易记录',
            showExist: true,
            name: 'pay_record',
            cprops: {},
        });
    };
    MyWallet.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.service
            .getRechargeBillList(Object.assign({ payment_status: this.payStatus }, pager))
            .then(function (res) {
            _this.listData = res.data.data;
            _this.total = res.data.total;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MyWallet.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    MyWallet.prototype.getWallet = function () {
        var _this = this;
        this.service
            .getWallet()
            .then(function (res) {
            _this.walletData = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MyWallet.prototype.explain = function () {
        var html = "<div>\u2460\u53EF\u7528\u4F59\u989D\uFF1A\u4F01\u4E1A\u53EF\u652F\u914D\u7684\u989D\u5EA6\uFF0C\u542B\u8D60\u9001\u91D1\u989D\uFF08\u5E73\u53F0\u4E3A\u6BCF\u4F4D\u4F9B\u5E94\u5546\u5206\u914D\u4E86\u4E3B\u8D26\u6237\u3001\u526F\u8D26\u6237\uFF0C\u5176\u4E2D\u526F\u8D26\u6237\u4E3A\u8D60\u9001\u7C7B\u91D1\u989D\uFF09\uFF1B<br/>\u2461\u51BB\u7ED3\u91D1\u989D\uFF1A\u4F7F\u7528\u5E73\u53F0\u4ED8\u8D39\u670D\u52A1\u65F6\u5DF2\u51BB\u7ED3\u7684\u91D1\u989D\u3002\u51BB\u7ED3\u89E3\u51BB\u4E1A\u52A1\u9879\u8BF4\u660E\u5982\u4E0B\uFF1A<br/>\u2022 \u62A5\u4EF7\u51BB\u7ED3\uFF1A\u53C2\u4E0E\u62A2\u5546\u673A\u62A5\u4EF7\u65F6\u5C06\u51BB\u7ED3\u76F8\u5E94\u91D1\u989D\uFF0C\u4E14\u5728\u9700\u6C42\u65B9\u8BC4\u5BA1\u540E\u65B9\u6263\u6B3E\uFF1B<br/>\u2022 \u62A5\u4EF7\u89E3\u51BB\uFF1A\u5728\u672A\u8BC4\u5BA1\u60C5\u51B5\u4E0B\uFF0C\u4F9B\u5E94\u5546\u4E3B\u52A8\u64A4\u9500\u62A5\u4EF7\u3001\u9700\u6C42\u81EA\u52A8\u5230\u671F\u3001\u9700\u6C42\u65B9\u4E3B\u52A8\u7ED3\u675F\u62A5\u4EF7\u3001\u56E0\u4E0D\u7B26\u5408\u5E73\u53F0\u89C4\u8303\u88AB\u4E0B\u67B6\u65F6\u5C06\u5E9F\u5F03\u62A5\u4EF7\uFF0C\u76F8\u5E94\u51BB\u7ED3\u91D1\u989D\u81EA\u52A8\u89E3\u51BB\uFF0C\u8BE5\u989D\u5EA6\u81EA\u52A8\u7D2F\u52A0\u81F3\u201C\u53EF\u7528\u4F59\u989D\u201D\u5904\u3002</div>";
        this.$confirm(html, '说明', {
            dangerouslyUseHTMLString: true,
            customClass: 'confirm',
            confirmButtonText: '关闭',
            showCancelButton: false,
        });
    };
    MyWallet.prototype.destroyed = function () {
        this.timer && clearInterval(this.timer);
    };
    __decorate([
        Watch('payStatus')
    ], MyWallet.prototype, "watchPayStatus", null);
    MyWallet = __decorate([
        Component
    ], MyWallet);
    return MyWallet;
}(Vue));
export default MyWallet;
